export const toIdentifierArray = (value) => {
  const values = Array.isArray(value) ? value : [value];
  return [
    ...new Set(
      values.flatMap((item) =>
        String(item ?? "")
          .split(/[\s,;]+/)
          .map((entry) => entry.trim())
          .filter(Boolean)
          .map((entry) => Number(entry)),
      ),
    ),
  ];
};

export const formatIdentifierList = (value) =>
  toIdentifierArray(value).join(", ");

export const parseIdentifierList = (value, label) => {
  const entries = String(value || "")
    .split(/[\s,;]+/)
    .map((entry) => entry.trim())
    .filter(Boolean);

  if (entries.some((entry) => !/^\d+$/.test(entry))) {
    throw new Error(`${label} values must be whole numbers.`);
  }

  const values = toIdentifierArray(entries);
  if (values.some((entry) => !Number.isSafeInteger(entry))) {
    throw new Error(`${label} contains an unsupported value.`);
  }
  return values;
};

